export const bankDetailsOCRStyles = {
  root: {
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 148px)',
    padding: '16px',
    pb: 0,
    overflowY: 'auto',
    gap: '16px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    flex: 1,
    gap: 0,
    pb: '75px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  stepText: {
    color: 'rgba(0, 0, 0, 0.38)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '266%',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    height: '32px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  titleRow: {
    display: 'flex',
    gap: 0.75,
    alignItems: 'center',
    height: '32px',
  },
  titleText: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },
  requiredMark: {
    fontFamily: "Noto Sans",
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '32px',
    color: '#c62828',
  },
  subtitleText: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '143%',
    letterSpacing: '0.17px',
    display: 'flex',
    height: '40px',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  uploadArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    maxWidth: 900,
    aspectRatio: '1.6 / 1',
    padding: 0,
    backgroundColor: '#FFFFFF',
    gap: 0,
    alignSelf: 'center',
    borderRadius: '8px',
    border: '1px solid var(--divider, rgba(0, 0, 0, 0.12))',
    overflow: 'hidden',
  },
  previewSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    textAlign: 'center',
    width: '100%',
  },
  previewCircle: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#ECECF0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  previewIcon: {
    color: '#76768A',
    fontSize: 44,
  },
  instructionText: {
    fontFamily: "'Noto Sans', sans-serif",
    color: '#717182',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.15px',
  },
  actionRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: { xs: 1.5, sm: 3 },
    maxWidth: 900,
    alignSelf: 'center',
  },
  actionItem: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#BBD8E4',
      backgroundColor: '#FFFFFF',
    },
    borderRadius: '8px',
  },
  cameraActionItem: {
    border: '2px dashed #B2EAF2',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #E0F7FA 100%)',
  },
  galleryActionItem: {
    border: '2px dashed  #DDCEDB',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #F6EAF2 100%)',
  },
  actionIconCircle: {
    display: 'flex',
    width: 48,
    height: 48,
    padding: '10.537px 9.951px 9.366px 9.951px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cameraActionIconCircle: {
    borderRadius: '234.146px',
    background: 'var(--common-white_states-main, #FFF)',
  },
  galleryActionIconCircle: {
    borderRadius: '234.146px',
    background: 'var(--common-white_states-main, #FFF)',
  },
  cameraCard: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    cursor: 'pointer',
    borderRadius: '8px',
    border: '2px dashed #B2EAF2',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #E0F7FA 100%)',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#BBD8E4',
      backgroundColor: '#FFFFFF',
    },
  },
  galleryCard: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    cursor: 'pointer',
    borderRadius: '8px',
    border: '2px dashed #DDCEDB',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #F6EAF2 100%)',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#BBD8E4',
      backgroundColor: '#FFFFFF',
    },
  },
  uploadIconWrap: {
    display: 'flex',
    width: 48,
    height: 48,
    padding: '10.537px 9.951px 9.366px 9.951px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '234.146px',
    background: 'var(--common-white_states-main, #FFF)',
  },
  galleryUploadIconWrap: {
    display: 'flex',
    width: 48,
    height: 48,
    padding: '10.537px 9.951px 9.366px 9.951px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '234.146px',
    background: 'var(--common-white_states-main, #FFF)',
  },
  cameraIcon: {
    color: '#0E98AF',
    width: 40,
    height: 40,
  },
  galleryIcon: {
    color: '#6F5674',
    width: 40,
    height: 40,
  },
  primaryUploadText: {
    color: 'rgba(0, 0, 0, 0.87)',
    textAlign: 'center',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '175%',
    letterSpacing: '0.15px',
  },
  actionTitle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '175%',
    letterSpacing: '0.15px',
  },
  actionSubtitle: {
    color: 'rgba(0, 0, 0, 0.60)',
    textAlign: 'center',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '143%',
    letterSpacing: '0.17px',
  },
  secondaryUploadText: {
    color: '#717182',
    textAlign: 'center',
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '16px',
  },
  hiddenFileInput: {
    position: 'absolute' as const,
    width: 0,
    height: 0,
    opacity: 0,
    overflow: 'hidden',
    pointerEvents: 'none' as const,
  },
  previewWrap: {
    position: 'relative',
    width: '100%',
    height: '100%',
    flex: 1,
    borderRadius: 'inherit',
    overflow: 'hidden',
    margin: 0,
  },
  previewImage: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  deleteImageButton: {
    position: 'absolute',
    bottom: 16,
    right: 16,
    bgcolor: 'white',
    boxShadow: '1px 2px 6px 0px rgba(0,0,0,0.16)',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: '50%',
    '&:hover': {
      bgcolor: '#f5f5f5',
    },
  },
  editImageButton: {
    display: 'inline-flex',
    padding: '4px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '80px',
    background: 'rgba(0, 0, 0, 0.56)',
    boxShadow: '1px 2px 6px 0 rgba(0, 0, 0, 0.16)',
    position: 'absolute',
    bottom: 12,
    right: 12,
    cursor: 'pointer',
  },
  editButtonText: {
    color: 'var(--common-white_states-main, #FFF)',
    fontFamily: "Noto Sans",
    fontSize: '13px',
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "22px",
    letterSpacing: "0.46px",
  },
  inlineLoaderOverlay: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    width: '100%',
    borderRadius: '12px',
  },
  inlineLoaderIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#16A34A',
  },
  inlineLoaderStatusText: {
    color: '#166534',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.17px',
  },
  verifiedRow: {
    display: 'flex',
    gap: 1.5,
    alignItems: 'flex-start',
  },
  checkIconLarge: {
    color: '#0EA01A',
    fontSize: 24,
  },
  checkIconSmall: {
    color: '#0EA01A',
    fontSize: 20,
  },
  statusText: (isVerified: boolean) => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: isVerified ? '#00820d' : '#B71B1C',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  }),
  verifiedNameText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    color: '#007d00',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  nameMismatchAlertRow: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    gap: '5px',
    alignSelf: 'stretch',
    background:  '#F4F4F4',
  },
  nameMismatchAlertText: {
    fontFamily: "Noto Sans",
    fontWeight: 400,
    fontSize: '12px',
    color: '#333333',
    textAlign: 'left',
    fontStyle: 'normal',
    lineHeight: 'normal',
  },
  reasonSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    width: '100%',
    maxWidth: 360,
    mt: 0.5,
  },
  reasonLabelRow: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center',
  },
  reasonLabelText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.1px',
  },
  reasonAsteriskText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: '#b71b1c',
    letterSpacing: '0.1px',
  },
  reasonInputWrap: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    py: 2,
    px: 1.5,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    height: '56px',
    width: '105%',
    '&:hover': {
      borderColor: 'rgba(0, 0, 0, 0.87)',
    },
  },
  reasonValueText: (hasValue: boolean) => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: hasValue ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.15px',
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'left',
  }),
  reasonChevronWrap: {
    width: 24,
    height: 24,
    flexShrink: 0,
  },
  viewDetailsLink: {
    display: 'inline',
    color: '#B71B1C',
    fontFamily: "Noto Sans",
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'auto',
    textDecorationThickness: '10%',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  attemptsWarningRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  errorIconWrap: {
    mt: '2px',
    display: 'flex',
  },
  attemptsWarningText: {
    color: '#B71B1C',
    fontFamily: "Noto Sans",
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    mt:1,
  },
  fieldLabelRow: {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center',
  },
  fieldLabel: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '0.1px',
  },
  accountTypeSelect: {
    position: 'relative',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    py: 2,
    px: 1.5,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      borderColor: 'rgba(0, 0, 0, 0.87)',
    },
  },
  accountTypeValue: (hasValue: boolean) => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: hasValue ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.15px',
    flex: 1,
  }),
  accountTypeChevronWrap: {
    width: 24,
    height: 24,
  },
  ifscClearAdornment: {
    cursor: 'pointer',
  },
  ifscClearIcon: {
    color: '#0000008F',
  },
  manualErrorRow: {
    display: 'flex',
    gap: 1,
    alignItems: 'flex-start',
  },
  manualErrorText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: '#b71b1c',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  manualAccountMismatchText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 13,
    color: '#b71b1c',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
  },
  manualVerifiedRow: {
    display: 'flex',
    gap: 1.5,
    alignItems: 'flex-start',
    mt: 0.5,
  },
  bottomBar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    bgcolor: 'white',
    display: 'flex',
    gap: 1.25,
    p: 2,
    pb: 'max(16px, env(safe-area-inset-bottom))',
  },
  backButton: {
    flex: 1,
    height: 42,
    border: '1px solid rgba(0, 124, 191, 0.5)',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    cursor: 'pointer',
    '&:hover': {
      bgcolor: 'rgba(0, 124, 191, 0.04)',
    },
  },
  backIcon: {
    color: '#007CBF',
    fontSize: 20,
  },
  backText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 15,
    color: '#007cbf',
    letterSpacing: '0.46px',
  },
  primaryButton: (enabled: boolean) => ({
    flex: 1,
    height: 42,
    bgcolor: enabled ? '#007cbf' : 'rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: enabled ? 'pointer' : 'not-allowed',
    '&:hover': {
      bgcolor: enabled ? '#006aa8' : 'rgba(0, 0, 0, 0.12)',
    },
  }),
  primaryButtonText: (enabled: boolean) => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 15,
    color: enabled ? 'white' : 'rgba(0, 0, 0, 0.38)',
    letterSpacing: '0.46px',
    textAlign: 'center',
    width: '100%',
  }),
  snackbar: {
    bottom: {
      xs: 90,
      sm: 0,
    },
    '& .MuiSnackbarContent-root': {
      display: 'flex',
      width: '320px',
      padding: '6px 16px',
      alignItems: 'center',
      gap: '16px',
    },
    '& .MuiSnackbarContent-message': {
      padding: 0,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      flex: 1,
      marginRight: '20px',
      color: 'var(--common-white_states-main, #FFF)',
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontFamily: 'Noto Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '143%',
      letterSpacing: '0.17px',
    },
    '& .MuiSnackbarContent-action': {
      marginRight: 0,
      padding: 0,
      flexShrink: 0,
    },
  },
  snackbarActionButton: {
    display: 'flex',
    padding: '4px 5px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'var(--Corner-s, 8px)',
    color: 'var(--primary-contrastText, #FFF)',
    fontFamily: 'Noto Sans',
    fontSize: 'var(--font-size-08125-rem, 13px)',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '22px',
    letterSpacing: '0.46px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus-visible': {
      outline: '2px solid #ffffff',
      outlineOffset: '3px',
      borderRadius: '2px',
    },
  },
  manualIfscSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  manualIfscErrorRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '24px',
  },
  manualIfscErrorIconWrap: {
    mt: '2px',
    display: 'flex',
  },
  manualIfscErrorText: {
    color: '#B71B1C',
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  manualIfscFieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  manualIfscLabel: {
    color: 'var(--text-primary, rgba(0, 0, 0, 0.87))',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: '"Noto Sans"',
    fontSize: 'var(--font-size-0875-rem, 14px)',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '157%',
    letterSpacing: '0.1px',
  },
  manualIfscAsterisk: {
    color: '#c62828',
    fontWeight: 600,
  },
  manualIfscInputRow: {
    display: 'flex',
    gap: '8px',
    alignItems: 'flex-start',
  },
  manualIfscTextField: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      fontFamily: '"Noto Sans"',
      fontSize: '16px', 
      display: 'flex',
      padding: '3px 12px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      borderRadius: 'var(--Corner-xs, 4px)',
      border: '1px solid var(--_components-input-outlined-enabledBorder, rgba(0, 0, 0, 0.23))',
      backgroundColor: 'transparent',
    },
    '& .MuiOutlinedInput-input': {
      padding: '3px 0',
      backgroundColor: 'transparent',
      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 1000px white inset',
        WebkitTextFillColor: 'inherit',
      },
    },
    '& .MuiFormHelperText-root': {
      fontFamily: '"Noto Sans"',
      fontSize: '12px',
      marginLeft: '4px',
    },
  },
  manualIfscConfirmButton: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: '14px',
    textTransform: 'none',
    borderRadius: '8px',
    height: '40px',
    minWidth: '90px',
    borderColor: '#007CBF',
    color: '#007CBF',
    '&:hover': { borderColor: '#006aa8', color: '#006aa8' },
    '&.Mui-disabled': { borderColor: 'rgba(0,0,0,0.12)', color: 'rgba(0,0,0,0.38)' },
  },
  manualIfscHintText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.6)',
    mt: '2px',
  },
  manualIfscValidRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    mt: '4px',
  },
  manualIfscValidIcon: {
    color: '#0EA01A',
    fontSize: 20,
    mt: '1px',
  },
  manualIfscValidText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '14px',
    color: '#166534',
    lineHeight: 1.5,
  },
  manualIfscValidBoldText: {
    fontWeight: 700,
    fontSize: '14px',
  },
  manualIfscBankBranchText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.6)',
    mt: '2px',
  },
  gstInfoBox: {
    backgroundColor: '#F5F5F5',
    borderRadius: '8px',
    padding: '12px 16px',
    marginTop: '8px',
  },
  gstInfoText: {
    flex: '1 0 0',
    color: 'var(--Neutrals-Grey---High-Emphasis, #333)',
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  gstSectionTitle: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    marginTop: '16px',
    marginBottom: '8px',
  },
  gstSectionTitleText: {
    color: 'var(--text-primary, rgba(0, 0, 0, 0.87))',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },
  gstSectionAsterisk: {
    color: '#B71B1C',
    fontWeight: 700,
    fontSize: '16px',
  },
  gstUploadBox: {
    // border: '1.5px dashed #BDBDBD',
    // borderRadius: '12px',
    // padding: '20px 16px',
    // display: 'flex',
    // alignItems: 'center',
    // gap: '16px',
    // cursor: 'pointer',
    // transition: 'border-color 0.2s',
    // '&:hover': {
    //   borderColor: '#888',
    // },

    display: 'flex',
    padding: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    borderRadius: 'var(--Corner-s, 8px)',
    border: '2px dashed var(--Bayer-purple-100, #DDCEDB)',
    background: 'linear-gradient(180deg, var(--common-white_states-main, #FFF) 0%, var(--Bayer-purple-50, #F6EAF2) 100%)',
  },
  gstUploadIconWrap: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#F5F5F5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  gstUploadLabel: {
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    color: '#333',
  },
  gstUploadSubtext: {
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 400,
    color: 'rgba(0,0,0,0.5)',
  },
  gstUploadedBox: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
  },
  gstUploadStatusGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  gstUploadedIconWrap: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  gstUploadedFileName: {
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    color: '#333',
  },
  gstUploadedViewLink: {
    fontFamily: "'Noto Sans', sans-serif",
    fontSize: '13px',
    fontWeight: 600,
    color: '#1976D2',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  gstUploadedDeleteButton: {
    marginLeft: 'auto',
    color: '#757575',
    '&:hover': {
      color: '#B71B1C',
    },
  },
  gstUploadingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 0',
  },
  gstErrorText: {
    color: '#B71B1C',
    fontSize: '12px',
    lineHeight: '16px',
  },
  gstSuccessRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  gstSuccessIcon: {
    color: '#16A34A',
    fontSize: 24,
    marginTop: '2px',
    flexShrink: 0,
  },
  gstSuccessText: {
    color: '#007D00',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '143%',
    letterSpacing: '0.17px',
  },
};